import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import moment from 'moment';

import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

// Components
import NoTransaction from '../NoTransaction';
import CurrencyConverter from '../../CurrencyConverter';
import Link from '../../Link';
import CommonTable from '../../CommonTable/CommonTable';

// Locale
import messages from '../../../locale/jsonMessages';
import { dateFormat } from '../../../config';
import { formatLocalizedDate } from '../../../helpers/formatLocateDate';
import { hostPayoutAmount, paidHostTransaction } from '../../../helpers/hostPayoutAmount';

import cs from '../../commonStyle.css';
import s from '../Transaction.css';
class GrossEarnings extends Component {
  static propTypes = {
    formatMessage: PropTypes.any,
    data: PropTypes.arrayOf(PropTypes.shape({
      checkIn: PropTypes.string.isRequired,
      checkOut: PropTypes.string.isRequired,
      confirmationCode: PropTypes.number.isRequired,
      listData: PropTypes.shape({
        title: PropTypes.string.isRequired
      }),
      guestData: PropTypes.shape({
        firstName: PropTypes.string.isRequired
      }),
      hostTransaction: PropTypes.shape({
        payoutId: PropTypes.number,
        payEmail: PropTypes.string,
        amount: PropTypes.number,
        currency: PropTypes.string,
        createdAt: PropTypes.string
      })
    }))
  };

  static defaultProps = {
    data: []
  };

  tbody = (props) => {
    const { data } = props;
    const { locale } = this.props.intl;
    return data.map((item, index) => {
      let date = paidHostTransaction(item) ? moment(parseInt(item?.hostTransaction?.createdAt)).format(dateFormat?.usDateFormat) : 'Pending';
      let checkInDate = item?.checkIn ? formatLocalizedDate(item.checkIn, locale, dateFormat?.mediumDateFormat) : '';
      let checkOutDate = item?.checkOut ? formatLocalizedDate(item.checkOut, locale, dateFormat?.mediumDateFormat) : '';
      let totalAmount = hostPayoutAmount(item);
      let payoutAmount = item?.cancellationDetails, convertCurrency = item?.currency;
      if (payoutAmount) {
        totalAmount = item?.cancellationDetails?.payoutToHost ? (item?.cancellationDetails?.payoutToHost) : 0;
        convertCurrency = item?.cancellationDetails?.currency;
      }
      return {
        id: index,
        data: [
          {
            data: date
          },
          {
            data: <FormattedMessage {...messages.reservation} />
          },
          {
            data: <p className={cx(cs.noMargin)}>
              {checkInDate} - {checkOutDate} &nbsp;
              {item.listData && <Link to={"/users/trips/receipt/" + item.id} className={cx(s.confirmCodeColor)}>{item.confirmationCode}</Link>}
              {!item.listData && <span className={cx(s.confirmCodeColor)}>{item.confirmationCode}</span>}
            </p>
          },
          {
            data: <CurrencyConverter
              amount={totalAmount}
              from={convertCurrency}
            />
          }
        ]
      }
    })
  }

  thead = () => {
    const { formatMessage } = this.props.intl;
    return [
      { data: formatMessage(messages.transferDate) },
      { data: formatMessage(messages.transferType) },
      { data: formatMessage(messages.details) },
      { data: formatMessage(messages.grossEarnings) },
    ]
  };

  render() {
    const { data } = this.props;
    return (
      <div>
        {data.length > 0 &&
          <CommonTable
            thead={this.thead}
            tbody={() => this.tbody(this.props)}
            className={'payoutListTable'}
            data={data}
          />
        }
        {
          data.length === 0 && <div className={s.noTransactionSecSpace}>
            <NoTransaction className={s.noDataIconSec} />
          </div>
        }
      </div>
    );
  }
}

export default injectIntl(withStyles(s)(GrossEarnings));